import { Injectable } from '@angular/core';
import {
  ListAuxiliaryDataRequestInterface,
  ListAuxiliaryDataResponse,
  SalesOrdersAuxiliaryFieldDataApiService,
  UpsertAuxiliaryDataRequestInterface,
} from '@vendasta/sales-orders';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAuxiliaryDataSchemaService } from './_abstract.service';

@Injectable({
  providedIn: 'root',
})
export class OrderService implements AbstractAuxiliaryDataSchemaService {
  constructor(private readonly service: SalesOrdersAuxiliaryFieldDataApiService) {}

  listData(request: ListAuxiliaryDataRequestInterface): Observable<ListAuxiliaryDataResponse> {
    return this.service.listAuxiliaryData({
      salesOrderAuxiliaryDataObjectId: {
        businessId: request.auxiliaryDataObjectId.objectId.split('|')[0],
        orderId: request.auxiliaryDataObjectId.objectId.split('|')[1],
      },
      pagingOptions: request.pagingOptions,
    });
  }

  upsertData(request: UpsertAuxiliaryDataRequestInterface): Observable<null> {
    return this.service
      .upsertAuxiliaryData({
        salesOrderAuxiliaryDataObjectId: {
          businessId: request.auxiliaryDataObjectId.objectId.split('|')[0],
          orderId: request.auxiliaryDataObjectId.objectId.split('|')[1],
        },
        fieldDataUpsertOperations: request.fieldDataUpsertOperations,
      })
      .pipe(map(() => null));
  }
}
